module.exports = __webpack_public_path__ + "media/images/flags/32/Western-Sahara-d25d8b7bd9da775e78b07ee29a4ccaea.png";